module.exports = __webpack_public_path__ + "static/media/heroBanner.fdc1a413.jpg";